

'use strict';

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    $('.refinement.active').each(function () {
        $(this).removeClass('active');
        var activeDiv = $results.find('.' + $(this)[0].className.replace(/ /g, '.'));
        activeDiv.addClass('active');
        activeDiv.find('button.title').attr('aria-expanded', 'true');
    });
    const width = $(window).width();
    if (width > 700) {
        updateDom($results, '.refinements-desktop');
    } else {
        updateDom($results, '.refinements-mobile');

    }
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    var $results = $(response);
    var specialHandlers = {
        '.refinements': handleRefinements
    };

    // Update DOM elements that do not require special handling
    [
        '.grid-header',
        '.header-bar',
        '.header.page-title',
        '.product-grid',
        '.show-more',
        '.filter-bar'
    ].forEach(function (selector) {
        updateDom($results, selector);
    });

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });
}

/**
 * This function retrieves another page of content to display in the content search grid
 * @param {JQuery} $element - the jquery element that has the click event attached
 * @param {JQuery} $target - the jquery element that will receive the response
 * @return {undefined}
 */
function getContent($element, $target) {
    var showMoreUrl = $element.data('url');
    $.spinner().start();
    $.ajax({
        url: showMoreUrl,
        method: 'GET',
        success: function (response) {
            $target.append(response);
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    var $tempDom = $('<div>').append($(response));
    var sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
    sortOptions.forEach(function (option) {
        $('option.' + option.id).val(option.url);
    });
}

$(document).ready(function () {
    checkScreenWidth();

    // Attach an event handler to the resize event to recheck when the window size changes
    $(window).resize(function () {
        checkScreenWidth();
    });
});
function checkScreenWidth() {
    // Get the current window width
    var windowWidth = $(window).width();

    // Define the maximum width for mobile view (767 pixels)
    var mobileViewMaxWidth = 767;

    // Check if the window width is less than or equal to the mobile view max width
    if (windowWidth >= mobileViewMaxWidth) {
        // Remove the element with the ID "mobile-filter"
        $('#mobile-view-filter').remove()
    }
}
function openFilter(value) {
    var hideElements = document.getElementsByClassName('main-class-filter');

    for (let i = 0; i < hideElements.length; i++) {
        const hideElement = hideElements[i];
        hideElement.style.display = "none";
    }

    var element = document.getElementById(value);
    element.style.display = "block";
}

function closeFilter() {
    var hideElements = document.getElementsByClassName('main-class-filter');
    //hideElement.style.display = "none";
    for (let i = 0; i < hideElements.length; i++) {
        const hideElement = hideElements[i];
        hideElement.style.display = "none";
    }
}

$(".clear-cross").on('click', function () {
    closeFilter();
})

$(document).on('click', '.openFilterButton', function (e) {
    var fieldValue = $(this).attr('data-fieldId');
    openFilter(fieldValue);

});

// Handle refinement value selection and reset click
$('.container').on(
    'click',
    '.refinements li button,.refinements-mobile li button,.refinements-desktop li button,.refinements-mobile .range-slider,.refinements-desktop .range-slider .refinement-bar button.reset,.clear-cross, .filter-value button, .swatch-filter button',
    function (e) {
        e.preventDefault();
        e.stopPropagation();

        $.spinner().start();
        $(this).trigger('search:filter', e);
        var attributeId = '#' + $(this).find('span').last().attr('id');
        $.ajax({
            url: $(this).data('href'),
            data: {
                page: $('.grid-footer').data('page-number'),
                selectedUrl: $(this).data('href')
            },
            method: 'GET',
            success: function (response) {
                parseResults(response);
                $.spinner().stop();
                $(attributeId).parent('button').focus();
            },
            error: function () {
                $.spinner().stop();
                $(attributeId).parent('button').focus();
            }
        });
    });


//     $(".container").on(
//         "change",
//         ".refinements li button,.refinements-mobile li button,.refinements-desktop li button,.refinements-mobile .range-slider input[type=range],.refinements-desktop .range-slider input[type=range],.refinements .range-slider input[type=range], .refinements-desktop .range-slider input[type=range]", 
//         function(e){
//             if (
//                 (e.preventDefault(),
//                 e.stopPropagation(),
//                 $.spinner().start(),
//                 parseInt($("#range-min-value").val()) >
//                     parseInt($("#range-max-value").val()))
//             )
//             return (
//                 $("#range-min-value").val(
//                     parseInt($("input[name=range-1]").val())
//                 ),
//                 $("#range-max-value").val(
//                     parseInt($("input[name=range-2]").val())
//                 ),
//                 alert(
//                     "Incorrect price selection on price filter"
//                 ),
//                 $.spinner().stop(),
//                 !1
//             );
//             $(this).trigger("search:filter", e);
//             var attributeId= "#" + $(this).find("span").last().attr("id");
//             let urlEndPoint= $(this).data("href");
//             var deviceType = $("input[name=deviceType]").val() ? "desktop" : "mobile";
//             if ("minprice" == $(this).data("range")) {
//                 let url = $(this).data("href").split("?"),
//                     qString = url[1].split("&"),
//                     dType = "";
//                 qString.map((value) => {
//                     let rangePrice = value.split("=");
//                     "pmin" != rangePrice[0] &&
//                         "pmax" != rangePrice[0] &&
//                         (dType += value + "&");
//                 }),
//                     (urlEndPoint=
//                         url[0] +
//                         "?" +
//                         dType +
//                         "pmin=" +
//                         parseInt($("#range-min-value").val()) +
//                         "&pmax=" +
//                         parseInt($("#range-max-value").val()));
//             }

//             if ("maxprice" == $(this).data("range")) {
//                 let dataUrl = $(this).data("href").split("?"),
//                     urlValue = dataUrl[1].split("&"),
//                     dType = "";
//                 urlValue.map((value) => {
//                     let data = value.split("=");
//                     "pmin" != data[0] &&
//                         "pmax" != data[0] &&
//                         (dType += value + "&");
//                 }),
//                     (urlEndPoint=
//                         dataUrl[0] +
//                         "?" +
//                         dType +
//                         "pmin=" +
//                         parseInt($("#range-min-value").val()) +
//                         "&pmax=" +
//                         parseInt($("#range-max-value").val()));
//             }
            
//             let pLayout = $("#product-layout-type").val();

//             $.ajax({
//                 url: urlEndPoint,
//                 data: {
//                     page: $(".grid-footer").data("page-number"),
//                     selectedUrl: $(this).data("href"),
//                     productLayout: pLayout,
//                     deviceType: deviceType,
//                 },
//                 method: "GET",
//                 success: function (data) {
//                     parseResults(data),
//                         $.spinner().stop(),
//                         setTimeout(() => {
//                             $("#range-min-value").val(
//                                 parseInt(
//                                     localStorage.getItem(
//                                         "minprice"
//                                     )
//                                 )
//                             ),
//                                 $("#range-max-value").val(
//                                     parseInt(
//                                         localStorage.getItem(
//                                             "maxprice"
//                                         )
//                                     )
//                                 ),
//                                 $("input[name=range-1]").val(
//                                     parseInt(
//                                         localStorage.getItem(
//                                             "minprice"
//                                         )
//                                     )
//                                 ),
//                                 $("input[name=range-2]").val(
//                                     parseInt(
//                                         localStorage.getItem(
//                                             "maxprice"
//                                         )
//                                     )
//                                 );
//                         }, 23);
//                 },
//                 error: function () {
//                     $.spinner().stop(),
//                         $(attributeId).parent("button").focus();
//                 },
//             });
//         })

//         $(".container").on("click", ".clear-cross", function (t) {
//             $("input[name=range-1]").val(""),
//                 $("input[name=range-2]").val("");
//         });
        
// Display content results from the search
$('.container').on('click', '.content-search', function () {
    if ($('#content-search-results').html() === '') {
        getContent($(this), $('#content-search-results'));
    }
});

// Display the next page of content results from the search
$('.container').on('click', '.show-more-content button', function () {
    getContent($(this), $('#content-search-results'));
    $('.show-more-content').remove();
});

// Show more products
$('.container').on('click', '.show-more button', function (e) {
    e.stopPropagation();
    var showMoreUrl = $(this).data('url');
    e.preventDefault();

    $.spinner().start();
    $(this).trigger('search:showMore', e);
    $.ajax({
        url: showMoreUrl,
        data: { selectedUrl: showMoreUrl },
        method: 'GET',
        success: function (response) {
            $('.grid-footer').replaceWith(response);
            updateSortOptions(response);
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
});

$('.right-grids .nav-link').on('click', function() {
    var layout = $(this).data('layout');
    if(layout == 4){
        $('#product-layout-type').val(4);
        $("#flamingo").hide();
        $("#cuckoo").show();
        $('[name=sort-order]').trigger('change');
    }else if (layout == 2){
        $('#product-layout-type').val(2);
        $("#flamingo").show();
        $("#cuckoo").hide();
        $('[name=sort-order]').trigger('change');
    } else {
        $('#product-layout-type').val(1);
        $("#flamingo").hide();
        $("#cuckoo").show();
        $('[name=sort-order]').trigger('change');
    }
})

// Handle sort order menu selection
$('.container').on('change', '[name=sort-order]', function (e) {
    e.preventDefault();
    $.spinner().start();
    $(this).trigger('search:sort', this.value);
    var layoutValue = $('#product-layout-type').val();
    $.ajax({
      url: this.value,
      data: { selectedUrl: this.value },
      method: 'GET',
      success: function (response) {
        $('.product-grid').empty().html(response);
        $.spinner().stop();
        setTimeout(() => {
          if (layoutValue == 4) {
            $('.products-single').addClass('col-xl-3');
  
            $('.product-grid .product-img').addClass('col-md-3');
          } else if (layoutValue == 2) {
            $('.products-single').addClass('col-md-6');
            $('.product-grid .product-img').removeClass('col-sm-12');
            $('.product-grid .product-img').removeClass('col-md-12');
            $('.product-grid .product-img').addClass('col-md-6');
            $('.product-grid .product-img').addClass('col-sm-12');
  
  
            $('#flamingo .product-grid .product-img').addClass('col-md-3');
            $('#cuckoo .product-grid .product-img').removeClass('col-md-3');
  
          } else if (layoutValue == 1) {
            $('.products-single').addClass('col-sm-12');
            $('.product-grid .product-img').removeClass('col-md-3');
            $('.product-grid .product-img').addClass('col-md-12');
            $('.product-grid .product-img').addClass('col-sm-12');
          }
        }, 300);
      },
      error: function () {
        $.spinner().stop();
      }
    });
  });

// Close refinement bar and hide modal background if user resizes browser
$(window).resize(function () {
    $('.refinement-bar, .modal-background').hide();
    $('.refinement-bar').siblings().attr('aria-hidden', false);
    $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', false);
    $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', false);
    $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', false);
});

// Refinements close button
$('.container').on('click', '.refinement-bar button.close, .modal-background', function () {
    $('.refinement-bar, .modal-background').hide();
    $('.refinement-bar').siblings().attr('aria-hidden', false);
    $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', false);
    $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', false);
    $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', false);
    $('.btn.filter-results').focus();
});

// Display refinements bar when Menu icon clicked
$('.container').on('click', 'button.filter-results', function () {
    $('.refinement-bar, .modal-background').show();
    $('.refinement-bar').siblings().attr('aria-hidden', true);
    $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', true);
    $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', true);
    $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', true);
    $('.refinement-bar .close').focus();
});
